module.exports = __webpack_public_path__ + "img/1472341475.0b716a9b.jpg";